PS.Services.LocationService = window.location;
